<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3"><search-form :fields="search"/></el-button-group>

    <el-table :data="saleDailyStats" resource="sale-daily-stats" v-loading="loading">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column align="center" header-align="center" label="账号">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_name }})</span>
            <br />
            <span>{{ scope.row.user.mobile }}</span>
            <br />
            <span>{{ scope.row.user.idcard_no }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="stats_date" label="日期" width="130" />
      <el-table-column label="个人销售">
        <template slot-scope="scope">
          销售：
          <span class="color-warning">{{ scope.row.personal_amount }}</span>
          元
          <br />
          订单：
          <span class="color-info">{{ scope.row.personal_order_num }}</span>
          笔
          <br />
          产品：
          <span class="color-info">{{ scope.row.personal_pro_num }}</span>
          件
        </template>
      </el-table-column>
      <el-table-column label="直属销售">
        <template slot-scope="scope">
          销售：
          <span class="color-warning">{{ scope.row.directly_amount }}</span>
          元
          <br />
          订单：
          <span class="color-info">{{ scope.row.directly_order_num }}</span>
          笔
          <br />
          产品：
          <span class="color-info">{{ scope.row.directly_pro_num }}</span>
          件
        </template>
      </el-table-column>
      <el-table-column label="团队销售">
        <template slot-scope="scope">
          销售：
          <span class="color-warning">{{ scope.row.overall_amount }}</span>
          元
          <br />
          订单：
          <span class="color-info">{{ scope.row.overall_order_num }}</span>
          笔
          <br />
          产品：
          <span class="color-info">{{ scope.row.overall_pro_num }}</span>
          件
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer"><pagination :page="page" /></div>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getSaleDailyStats } from '@/api/sale-daily-stats'
import RowDestroy from '@c/LzTable/RowDestroy'
import RowToEdit from '@c/LzTable/RowToEdit'

export default {
  name: 'Index',
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
  },
  data() {
    return {
      search: [
        {
          field: 'keyword',
          label: '手机/姓名',
        },
        {
          field: 'created_at',
          label: '获得时间',
          type: 'date-picker',
        },
      ],
      saleDailyStats: [],
      page: null,
      loading: true,
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        const {
          data: { data, meta },
        } = await getSaleDailyStats(newVal.query)
        this.saleDailyStats = data
        this.page = meta
        this.loading = false
      },
      immediate: true,
    },
  },
}
</script>
